import { render, staticRenderFns } from "./GareArchiviate.vue?vue&type=template&id=7cf01e46&scoped=true&"
import script from "./GareArchiviate.vue?vue&type=script&lang=js&"
export * from "./GareArchiviate.vue?vue&type=script&lang=js&"
import style0 from "./GareArchiviate.vue?vue&type=style&index=0&id=7cf01e46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf01e46",
  null
  
)

export default component.exports